export default {
  cards: [
    {
      name: '钻石卡',
      price: '60,000RMB',
      icon: 'assets/member-icon4.png',
      basicRights: ['店内皮肤管理、头皮管理、身体智能管理指定项目享7.5折优惠', '医美类项目享8.5折优惠', '在售产品购买享8折优惠', '碳酸泉快捷净化：叠加其他护理时享会员价95元/次，独立操作时享会员价115元/次'],
      valueRightsTitle: '增值权益（以下9项中任选5项）',
      valueRights: [
        '礼品2选1：pdp客用三件套（价值756元）或pdp神经酰胺舒缓面霜1支+冰玲韵修复面膜1盒（价值536元）',
        '免费兑换日本碳酸泉头皮快捷净化服务5次',
        '面部自选项目（原价1，000元以内）享5折体验3次',
        '头皮自选项目（原价1，000元以内）享5折体验3次',
        'INDIBA身体智能管理（部位任选）享5折体验2次',
        '飞顿黑金超光子全模式面部护理享6.9折体验2次',
        '免费领取医美中心半岛逆时射频抗衰服务1次（价值1，600元）',
        '医美水光注射（适配品类自选）享6.9折体验1次',
        '医美类目自选项目享7.5折体验1次',
      ],
    },
    {
      name: '明星卡',
      price: '29,800RMB',
      icon: 'assets/member-icon3.png',
      basicRights: ['店内皮肤管理、头皮管理、身体智能管理指定项目享7.9折优惠', '医美类项目享9折优惠', '在售产品购买享8折优惠', '碳酸泉快捷净化：叠加其他护理时享会员价95元/次，独立操作时享会员价125元/次'],
      valueRightsTitle: '增值权益（以下6项中任选4项）',
      valueRights: [
        '礼品2选1：pdp补水面膜1盒（价值186元）或冰玲韵面膜1盒（价值168元）',
        '免费兑换日本碳酸泉头皮快捷净化服务2次',
        'pdp乳糖酸清洁管理项目享5折体验2次',
        'INDIBA身体智能管理（部位任选）享5折体验1次',
        '飞顿黑金超光子全模式面部护理享6.9折体验1次',
        '免费领取医美中心舒敏基础护理1次（价值690元）',
      ],
    },
    {
      name: 'VIP卡',
      price: '9,980RMB',
      icon: 'assets/member-icon2.png',
      basicRights: ['店内皮肤管理、头皮管理、身体智能管理部分项目享8.5折优惠', '医美项目享9.5折优惠', '在售产品购买享8折优惠', '碳酸泉快捷净化：叠加其他护理时享会员价95元/次，独立操作时享会员价125元/次'],
      valueRights: ['赠送pdp补水面膜或冰玲韵面膜1盒（2选1），价值186元/168元', '赠送日本碳酸泉头皮快捷净化服务1次'],
    },
    {
      name: '体验卡',
      price: '2,980RMB',
      icon: 'assets/member-icon1.png',
      basicRights: ['店内皮肤管理、头皮管理、身体智能管理部分项目享9折优惠'],
    },
  ],
  notes: ['不与店内其他优惠同享', '赠送项目及其他福利可放弃，但不可兑现、不可替换、不可折现', '所有折扣均以项目原始标价为计算基准', '医美的权益需前往FK医疗美容诊所', '特殊项目定价参照门店会员价格体系执行'],
  products: [
    { name: 'pdp乳糖酸毛穴孔清洁', time: '60m', price: '738', l1Price: '627', l2Price: '583', l3Price: '554' },
    { name: 'T区深层清洁', time: '45m', price: '308', l1Price: '262', l2Price: '243', l3Price: '231' },
    { name: '科技分层补水', time: '60m', price: '718', l1Price: '610', l2Price: '567', l3Price: '539' },
    { name: 'GeneoX氧气嫩肤', time: '60m', price: '1,750', l1Price: '1,488', l2Price: '1,383', l3Price: '1,313' },
    { name: 'WISHpro时光胶囊', time: '40m', price: '1,600', l1Price: '1,360', l2Price: '1,264', l3Price: '1,200' },
    { name: 'DEP婴儿胶原超导', time: '45m', price: '718', l1Price: '610', l2Price: '567', l3Price: '539' },
    { name: 'Timeless蓄热分层抗衰', time: '60m', price: '6,800', l1Price: '5,780', l2Price: '5,372', l3Price: '5,100' },
    { name: '豆腐柔肤', time: '60m', price: '1,608', l1Price: '1,367', l2Price: '1,270', l3Price: '1,206' },
    { name: 'P.01抗糖化温感石膏', time: '45m', price: '650', l1Price: '553', l2Price: '514', l3Price: '488' },
    { name: 'P.02油养肤温感石膏', time: '50m', price: '650', l1Price: '553', l2Price: '514', l3Price: '488' },
    { name: 'P.e1美目温感石膏（眼部）', time: '45m', price: '580', l1Price: '493', l2Price: '458', l3Price: '435' },
    { name: '补水修护舒缓泛红', time: '45m', price: '498', l1Price: '423', l2Price: '393', l3Price: '374' },
    { name: '白玉钻光', time: '60m', price: '838', l1Price: '712', l2Price: '662', l3Price: '629' },
    { name: '西班牙INDIBA眼部', time: '35m', price: '1,480', l1Price: '1,332', l2Price: '1,258', l3Price: '1,184' },
    { name: '西班牙INDIBA面/颈', time: '35m', price: '1,900', l1Price: '1,710', l2Price: '1,615', l3Price: '1,520' },
    { name: '西班牙INDIBA身体', time: '40m', price: '2,380', l1Price: '1,904', l2Price: '1,758', l3Price: '1,666' },
  ],
}; 